import { normalize, schema } from 'normalizr';
import { IState, ActionTypes } from './type';

const subdomainSchema = new schema.Entity('subdomains');
const subdomainListSchema = [subdomainSchema];

const initial: IState = {
  entities: {},
  ids: [],
  count: 0,
  loading: false,
};

const reducer = (state: IState = initial, action: any) => {
  switch (action.type) {
    case ActionTypes.REQUEST:
      return {
        ...state,
        loading: true
      };

    case ActionTypes.SUCCESS: {
      const normalizedData = normalize(action.payload.results, subdomainListSchema);

      return {
        ...state,
        entities: {
          ...state.entities,
          ...normalizedData.entities.subdomains,
        },
        ids: normalizedData.result as string[],
        count: action.payload.count as number,
        loading: false
      };
    }

    case ActionTypes.FAILURE:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}

export default reducer;
